<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between">
                <div class="align-self-center">
                  <button
                    class="btn btn-light d-flex align-items-center text-dark p-1 border-0"
                    @click="$router.go(-1)"
                  >
                    <i class="nc-icon nc-stre-left font-weight-bold"></i>
                    <p class="m-0 ml-1">Voltar a lista</p>
                  </button>
                </div>
              </div>
              <div class="mt-3">
                <div class="float-left">
                  <h4 class="card-title">Parceiros Cadastrados</h4>
                </div>
                <div class="float-right">
                  <button
                    @click="openNewprojectModal"
                    class="btn btn-success btn-fill"
                  >
                    Novo
                  </button>
                </div>
              </div>
            </template>

            <div class="ml-3 mb-4 mt-2">
              <label for="perfil" class="mb-3">Filtros</label>
              <div class="d-flex flex-column flex-sm-row">
                <div class="d-flex mr-0 mr-sm-5 mb-4 mb-sm-0 align-self-center">
                  <label for="ativo" class="d-flex align-items-center mb-0 pr-2"
                    >Nome</label
                  >
                  <input v-model="filtro.nome" class="form-control" />
                </div>
                <div class="d-flex">
                  <button @click="loadList()" class="btn btn-success mr-2">
                    Filtrar
                  </button>
                  <button
                    @click="limparFiltrosEBuscarLista()"
                    class="btn btn-danger mr-2"
                  >
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
            <l-table
              class="table-hover table-striped"
              :columns="tabelaProjetos.columns"
              :data="tabelaProjetos.data"
            >
              <template slot-scope="{ row }">
                <td>
                  <b>{{ row.nome }}</b>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <button
                      class="d-flex align-items-center btn btn-success btn-fill"
                      @click="handleChangeStatus(row)"
                      :disabled="getStatus(row.status).value === 'finalizado'"
                    >
                      <i class="fa fa-bars mr-2" />
                      <div>{{ getStatus(row.status).label }}</div>
                    </button>
                    <div
                      v-if="
                        row.dataUltimaAtualizacaoStatus &&
                          getStatus(row.status).value !== 'finalizado'
                      "
                      class="d-flex align-items-center ml-2"
                    >
                      <span class="text-muted mr-1">Data limite:</span>
                      <i
                        class="fa fa-clock-o text-muted mr-1"
                        aria-hidden="true"
                        title="Ao passar dessa data, um email de lembrete é enviado para o parceiro"
                        style="font-size: 1.15rem;"
                      ></i>
                      <span
                        class="mr-2"
                        :class="{ 'text-danger': isPrazoVencido(row) }"
                        title="Ao passar dessa data, um email de lembrete é enviado para o parceiro"
                      >
                        {{ getPrazoFormatado(row) }}
                      </span>
                      <span
                        v-if="row.emailLembreteEnviado"
                        class="fa-stack align-self-center ml-1"
                        title="Já foi enviado um email."
                        style="font-size: 1.15rem; line-height: 1;"
                      >
                        <i
                          class="fa fa-envelope fa-stack-1x text-muted"
                          aria-hidden="true"
                        ></i>
                        <i
                          class="fa fa-check fa-stack-1x text-success"
                          style="font-size: 0.6em; position: relative; top: -6px; left: 6px;"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'DocsEDadosDoProjeto',
                      params: {
                        idProjeto: row._id
                      }
                    }"
                    ><button
                      class="btn btn-icon btn-info"
                      style="margin-right: 10px"
                    >
                      <i class="fa fa-plus-square"></i>
                    </button>
                  </router-link>

                  <button
                    class="btn btn-icon btn-danger"
                    style="margin-right: 10px"
                    @click="handleDelete(row)"
                  >
                    <i class="fa fa-trash-o"></i>
                  </button>
                </td>
              </template>
            </l-table>
            <template slot="footer">
              <v-pagination
                v-if="tabelaProjetos.data.length > 0"
                v-model="currentPage"
                :page-count="totalPages"
                :classes="bootstrapPaginationClasses"
                :labels="paginationAnchorTexts"
              ></v-pagination>
            </template>
          </card>
        </div>
      </div>
    </div>
    <!-- CHANGE STATUS MODAL -->
    <div v-show="isChangeStatusModalVisible" @close="closeChangeStatusModal">
      <transition name="modal-fade">
        <div class="modal-backdrop">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  <strong>Deseja atualizar o status?</strong>
                </h5>
              </div>
              <div class="modal-body">
                <div v-if="status !== 'em_analise'" class="">
                  <label for="tecnologia">Status do projeto</label>
                  <select v-model="status" class="form-control">
                    <option
                      v-for="option in statusOptions"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    ></option>
                  </select>
                </div>
                <div v-else class="">
                  <div class="">
                    <label for="tecnologia">Status do projeto</label>
                    <select v-model="status" class="form-control">
                      <option
                        v-for="option in statusOptions"
                        :value="option.value"
                        :label="option.label"
                        :key="option.label"
                      ></option>
                    </select>
                  </div>
                  <div class="mt-3">
                    <label for="concessionaria">Concessionária</label>
                    <select
                      id="concessionaria"
                      v-model="concessionariaId"
                      class="form-control"
                    >
                      <option value="">Selecione uma concessionária</option>
                      <option
                        v-for="c in concessionariasList"
                        :key="c._id"
                        :value="c._id"
                      >
                        {{ c.nome }}
                      </option>
                    </select>
                  </div>
                  <div class="mt-3">
                    <label class="mb-1">Administrador</label>
                    <multiselect
                      v-model="administradorSelecionado"
                      :options="listaAdministradores"
                      :showLabels="false"
                      placeholder="Selecione um administrador"
                      :customLabel="administradorLabel"
                      :allow-empty="false"
                    >
                      <span slot="noResult">Não encontrado</span>
                    </multiselect>
                  </div>
                  <div class="mt-3">
                    <base-input
                      v-model="protocoloModal"
                      type="text"
                      label="Protocolo"
                      placeholder="Protocolo"
                    />
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click.prevent
                    @click="closeChangeStatusModal()"
                  >
                    Fechar
                  </button>
                  <button
                    type="button"
                    class="btn btn-success btn-fill"
                    @click.prevent
                    @click="atualizarStatus()"
                  >
                    Atualizar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- DELETE MODAL -->
    <div v-show="isDeleteModalVisible" @close="closeDeleteModal">
      <transition name="modal-fade">
        <div class="modal-backdrop">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  <strong>Deseja realmente excluir o projeto?</strong>
                </h5>
              </div>
              <div class="modal-body">
                Esta ação é definitiva e não poderá ser desfeita.
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click.prevent
                  @click="closeDeleteModal()"
                >
                  Fechar
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click.prevent
                  @click="deletarParceiro()"
                >
                  Deletar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- NEW PROJECT MODAL -->
    <div v-show="isNewProjectModalVisible" @close="closeNewProjectModal">
      <transition name="modal-fade">
        <div class="modal-backdrop">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  <strong>Preencha o nome do projeto</strong>
                </h5>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-12">
                    <base-input
                      type="text"
                      placeholder="Nome"
                      v-model="nomeDoNovoProjeto"
                    />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click.prevent
                  @click="closeNewProjectModal()"
                >
                  Fechar
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click.prevent
                  @click="createNewProject()"
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- EXTENDER PRAZO MODAL -->
    <div v-show="isExtenderPrazoModalVisible" @close="closeExtenderPrazoModal">
      <transition name="modal-fade">
        <div class="modal-backdrop">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  <strong>Escolha um novo prazo para o projeto</strong>
                </h5>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-12">
                    <label for="novoPrazo">Nova data de prazo</label>
                    <date-picker
                      v-model="novoPrazo"
                      :disabled-date="disabledDate"
                      format="DD/MM/YYYY"
                      value-type="date"
                      placeholder="Selecione uma data"
                      input-class="form-control"
                    />
                    <div v-if="qtdDeDias > 0" class="text-center mt-3">
                      <label class="text-info">
                        O prazo será atualizado em mais {{ qtdDeDias }} dias.
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click.prevent
                  @click="closeExtenderPrazoModal()"
                >
                  Fechar
                </button>
                <button
                  type="button"
                  class="btn btn-success btn-fill"
                  @click.prevent
                  @click="estenderPrazo()"
                  :disabled="!novoPrazo || qtdDeDias <= 0"
                  :style="
                    !novoPrazo || qtdDeDias <= 0
                      ? 'background-color: #ccc; border-color: #ccc;'
                      : ''
                  "
                >
                  Atualizar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import Modal from 'src/components/Modal';
import DatePicker from 'vue2-datepicker';
import LTable from 'src/components/Table.vue';
import vPagination from 'vue-plain-pagination';
import ParceiroProjectService from 'src/services/parceiroProject';
import ConcessionariasService from 'src/services/concessionarias';
import UserServices from 'src/services/usuarios';
import _ from 'lodash';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;
const tableColumns = ['Nome'];
export default {
  components: {
    Multiselect,
    DatePicker,
    Modal,
    LTable,
    vPagination
  },
  data() {
    return {
      nomeDoNovoProjeto: '',
      statusOptions: [
        { value: 'recebido', label: 'Recebido' },
        { value: 'elaboracao', label: 'Elaboracao' },
        { value: 'em_analise', label: 'Em análise' },
        { value: 'aprovado', label: 'Aprovado' },
        { value: 'aguardando_inspecao', label: 'Aguardando Inspeção' },
        { value: 'reanalise', label: 'Reanálise' },
        { value: 'reprovado_por_debito', label: 'Reprovado por débito' },
        { value: 'obra', label: 'Obra' },
        { value: 'finalizado', label: 'Finalizado' }
      ],
      status: '',
      concessionariaId: '',
      concessionariasList: [],
      listaAdministradores: [],
      administradorSelecionado: null,
      protocoloModal: '',
      isChangeStatusModalVisible: false,
      projectToChangeStatus: {},
      tabelaProjetos: {
        columns: [...tableColumns],
        data: []
      },
      currentPage: 1,
      totalPages: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      paginationAnchorTexts: {
        first: 'Primeira',
        prev: '<',
        next: '>',
        last: 'Última'
      },
      projectsTable: [],
      isDeleteModalVisible: false,
      isNewProjectModalVisible: false,
      isExtenderPrazoModalVisible: false,
      projectToDelete: {},
      projectToExtend: {},
      novoPrazo: null,
      qtdDeDias: 0,
      filtro: {
        nome: ''
      }
    };
  },
  created() {
    this.codigoParceiro = this.$router.history.current.params.codigoParceiro;
    this.checkExtenderParam();
    this.loadList();
  },
  methods: {
    getPrazoFormatado(row) {
      try {
        const prazoDate = this.getPrazoDate(row);
        return prazoDate ? this.formatDate(prazoDate) : '';
      } catch (e) {
        return '';
      }
    },
    getPrazoDate(row) {
      if (!row.dataUltimaAtualizacaoStatus) return null;
      const baseDate = new Date(row.dataUltimaAtualizacaoStatus);
      if (isNaN(baseDate.getTime())) return null;
      const dias = this.getPrazoDias(row);
      return this.addDays(baseDate, dias);
    },
    isPrazoVencido(row) {
      const prazoDate = this.getPrazoDate(row);
      if (!prazoDate) return false;
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      const prazo = new Date(prazoDate);
      prazo.setHours(0, 0, 0, 0);
      return prazo < hoje;
    },
    getPrazoDias(row) {
      if (row && (row.prazoCustomizado || row.prazoCustomizado === 0)) {
        return Number(row.prazoCustomizado) || 0;
      }
      return this.getPrazoDiasPadraoPorStatus(row.status);
    },
    getPrazoDiasPadraoPorStatus(status) {
      // Valores padrão (ajuste conforme necessário quando disponibilizados)
      const mapa = {
        recebido: 2,
        elaboracao: 4,
        em_analise: 15,
        aprovado: 180,
        aguardando_inspecao: 10,
        reanalise: 15,
        reprovado_por_debito: 0,
        obra: 120,
        finalizado: 0
      };
      return mapa[status] != null ? mapa[status] : 0;
    },
    addDays(date, days) {
      const d = new Date(date.getTime());
      d.setDate(d.getDate() + Number(days || 0));
      return d;
    },
    formatDate(date) {
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yyyy = date.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    },
    createNewProject() {
      if (this.nomeDoNovoProjeto && this.codigoParceiro) {
        const loader = this.$loading.show({
          color: VUE_APP_SPINNER_COLOR
        });

        ParceiroProjectService.create({
          nome: this.nomeDoNovoProjeto,
          codigo: this.codigoParceiro
        })
          .then(() => {
            this.$notifications.notify({
              message: 'Salvo com sucesso',
              type: 'success'
            });
            this.closeNewProjectModal();
            this.loadList();
            loader.hide();
          })
          .catch(error => {
            loader.hide();
            this.closeNewProjectModal();
            const message =
              _.get(error, 'response.status') === 400 &&
              _.has(error, 'response.data.message')
                ? _.get(error, 'response.data.message')
                : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

            this.$notifications.notify({
              message,
              type: 'danger'
            });
          });
      }
    },
    loadList() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      ParceiroProjectService.listar({
        page: this.currentPage,
        codigoParceiro: this.codigoParceiro,
        nome: this.filtro.nome
      })
        .then(response => {
          this.tabelaProjetos.data = _.get(response, 'data.result');
          this.totalItens = _.get(response, 'data.count');
          this.totalPages = Math.ceil(this.totalItens / 10);
          loader.hide();
        })
        .catch(error => {
          loader.hide();

          const message =
            _.get(error, 'response.status') === 400 &&
            _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.$notifications.notify({
            message,
            type: 'danger'
          });
        });
    },
    handleChangeStatus(row) {
      this.status = this.getStatus(row.status).value;
      this.isChangeStatusModalVisible = true;
      this.projectToChangeStatus = row;
      const currentConcessionariaId =
        row.concessionariaId ||
        (row.concessionaria && row.concessionaria._id) ||
        '';
      this.concessionariaId = currentConcessionariaId;
      this.protocoloModal = row.protocolo || '';
      this.administradorSelecionado = row.colaborador || null;
      if (this.status === 'em_analise') {
        this.loadConcessionarias();
        this.loadAdministradores();
      }
    },

    closeChangeStatusModal() {
      this.isChangeStatusModalVisible = false;
      this.concessionariaId = '';
      this.concessionariasList = [];
      this.listaAdministradores = [];
      this.administradorSelecionado = null;
      this.protocoloModal = '';
    },
    loadConcessionarias() {
      ConcessionariasService.listar({ page: 1, limit: 100 })
        .then(response => {
          this.concessionariasList = _.get(response, 'data.result', []);
          const project = this.projectToChangeStatus;
          if (project && project.concessionaria && project.concessionaria._id) {
            const exists = this.concessionariasList.some(
              c => c._id === project.concessionaria._id
            );
            if (!exists) {
              this.concessionariasList = [
                project.concessionaria,
                ...this.concessionariasList
              ];
            }
          }
        })
        .catch(() => {
          this.concessionariasList = [];
        });
    },
    loadAdministradores() {
      UserServices.listarAdministradores()
        .then(response => {
          this.listaAdministradores = response.data || [];
          const project = this.projectToChangeStatus;
          if (project && project.colaborador && project.colaborador._id) {
            const exists = this.listaAdministradores.some(
              u => u._id === project.colaborador._id
            );
            if (!exists) {
              this.listaAdministradores = [
                project.colaborador,
                ...this.listaAdministradores
              ];
            }
            this.administradorSelecionado = this.listaAdministradores.find(
              u => u._id === project.colaborador._id
            );
          }
        })
        .catch(() => {
          this.listaAdministradores = [];
        });
    },
    administradorLabel(user) {
      if (!user) return '';
      return user.tipoParceiro === 'pf'
        ? `${user.nome} ${user.sobrenome}`
        : user.razaoSocial || '';
    },
    createLoading() {
      return this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
    },
    getStatus(statusValue) {
      const status = this.statusOptions.find(s => s.value === statusValue);
      if (status) {
        return status;
      }
      return { value: '', label: '' };
    },
    atualizarStatus() {
      const currentProjectStatus = this.getStatus(
        this.projectToChangeStatus.status
      );
      if (this.status === currentProjectStatus.value) {
        this.notify({
          type: 'info',
          message: 'Selecione um status diferente do atual para atualizar'
        });
        return;
      }
      if (this.status === 'em_analise' && !this.concessionariaId) {
        this.notify({
          type: 'info',
          message: 'Selecione uma concessionária para o status Em análise'
        });
        return;
      }
      if (this.status === 'em_analise' && !this.administradorSelecionado) {
        this.notify({
          type: 'info',
          message: 'Selecione um administrador para o status Em análise'
        });
        return;
      }

      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const payload = {
        newStatus: this.status,
        projectId: this.projectToChangeStatus._id
      };
      if (this.status === 'em_analise' && this.concessionariaId) {
        payload.concessionariaId = this.concessionariaId;
      }
      if (this.status === 'em_analise' && this.administradorSelecionado) {
        payload.colaboradorId = this.administradorSelecionado._id;
        payload.protocolo =
          this.protocoloModal && String(this.protocoloModal).trim()
            ? String(this.protocoloModal).trim()
            : null;
      }

      ParceiroProjectService.atualizarStatus(payload)
        .then(() => {
          this.notify({
            message: 'Status atualizado com sucesso',
            type: 'success'
          });
          this.loadList();
          this.closeChangeStatusModal();
          loader.hide();
        })
        .catch(error => {
          loader.hide();

          const message =
            _.get(error, 'response.status') === 400 &&
            _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.notify({
            message,
            type: 'danger'
          });
        });
    },
    handleDelete(row) {
      this.isDeleteModalVisible = true;
      this.projectToDelete = row;
    },
    closeDeleteModal() {
      this.isDeleteModalVisible = false;
      this.projectToDelete = {};
    },
    openNewprojectModal() {
      this.isNewProjectModalVisible = true;
    },
    closeNewProjectModal() {
      this.isNewProjectModalVisible = false;
      this.nomeDoNovoProjeto = '';
    },
    deletarParceiro() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      ParceiroProjectService.deletar({
        projectId: this.projectToDelete._id
      })
        .then(() => {
          this.notify({
            message: 'Deletado com sucesso',
            type: 'success'
          });
          this.loadList();
          this.closeDeleteModal();
          loader.hide();
        })
        .catch(error => {
          loader.hide();

          const message =
            _.get(error, 'response.status') === 400 &&
            _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.notify({
            message,
            type: 'danger'
          });
        });
    },
    notify({ type, message }) {
      let icon = '';
      switch (type) {
        case 'info':
          icon = 'fa fa-info';
          break;
        case 'success':
          icon = 'fa fa-check';
          break;
        case 'danger':
          icon = 'fa fa-exclamation-triangle';
      }
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: type
      });
    },
    limparFiltrosEBuscarLista() {
      this.filtro = {
        nome: ''
      };
      this.loadList();
    },
    checkExtenderParam() {
      const urlParams = new URLSearchParams(window.location.search);
      const extenderId = urlParams.get('ep');
      if (extenderId) {
        this.projectToExtend = { _id: extenderId };
        this.isExtenderPrazoModalVisible = true;
      }
    },
    disabledDate(date) {
      // Desabilitar datas de hoje e anteriores
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date <= today;
    },
    closeExtenderPrazoModal() {
      this.isExtenderPrazoModalVisible = false;
      this.projectToExtend = {};
      this.novoPrazo = null;
      this.qtdDeDias = 0;
      // Remover parâmetro da URL
      const url = new URL(window.location);
      url.searchParams.delete('ep');
      window.history.replaceState({}, '', url);
    },
    estenderPrazo() {
      if (!this.novoPrazo || !this.projectToExtend._id) {
        return;
      }

      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      // Calcular diferença em dias
      const hoje = new Date();
      const dataSelecionada = new Date(this.novoPrazo);
      const diffTime = dataSelecionada.getTime() - hoje.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      ParceiroProjectService.estenderPrazo({
        projectId: this.projectToExtend._id,
        novoPrazo: diffDays
      })
        .then(() => {
          this.notify({
            message: 'Prazo estendido com sucesso',
            type: 'success'
          });
          this.closeExtenderPrazoModal();
          this.loadList();
          loader.hide();
        })
        .catch(error => {
          loader.hide();

          const message =
            _.get(error, 'response.status') === 400 &&
            _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.notify({
            message,
            type: 'danger'
          });
        });
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (this.currentPage !== oldValue) {
        this.loadList();
      }
    },
    status: function(newVal) {
      if (newVal === 'em_analise') {
        this.loadConcessionarias();
        this.loadAdministradores();
      }
    },
    novoPrazo: function(newValue) {
      if (newValue) {
        const hoje = new Date();
        const dataSelecionada = new Date(newValue);
        const diffTime = dataSelecionada.getTime() - hoje.getTime();
        this.qtdDeDias = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      } else {
        this.qtdDeDias = 0;
      }
    }
  }
};
</script>
<style scoped>
.height-fit-content {
  height: fit-content;
}
.crm-tabs .nav {
  display: block !important;
}

.relatorio-geracao-form {
  border-bottom: 1px solid #e0e0e0;
}
.buttons-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

/* Estilo para o datepicker */
.mx-datepicker {
  margin-left: 8px;
}

.mx-datepicker .mx-input-wrapper .form-control {
  cursor: pointer !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
